var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelPinterestFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  fill: "#CC2127",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M12.272 6.214C9.1 6.214 7.5 8.478 7.5 10.366c0 1.144.435 2.16 1.367 2.54.153.062.29.002.335-.167l.136-.533c.045-.167.028-.225-.096-.37-.269-.316-.44-.725-.44-1.304 0-1.68 1.262-3.184 3.287-3.184 1.793 0 2.779 1.091 2.779 2.548 0 1.916-.852 3.534-2.117 3.534-.699 0-1.222-.576-1.054-1.28.2-.843.59-1.752.59-2.36 0-.543-.294-.997-.902-.997-.714 0-1.287.735-1.287 1.72 0 .628.213 1.052.213 1.052l-.86 3.622c-.254 1.075-.038 2.393-.02 2.526.011.078.113.097.16.038.065-.086.916-1.131 1.205-2.175.082-.296.47-1.827.47-1.827.232.44.91.828 1.63.828 2.148 0 3.604-1.948 3.604-4.555 0-1.972-1.678-3.808-4.228-3.808"
}))));
export default SvgGemChannelPinterestFilled;